import { render, staticRenderFns } from "./xunjiandangan.vue?vue&type=template&id=398e9de3&scoped=true"
import script from "./xunjiandangan.vue?vue&type=script&lang=js"
export * from "./xunjiandangan.vue?vue&type=script&lang=js"
import style0 from "./xunjiandangan.vue?vue&type=style&index=0&id=398e9de3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398e9de3",
  null
  
)

export default component.exports